import { render, staticRenderFns } from "./AgencyContestParagraphsTable.vue?vue&type=template&id=6235e73c&scoped=true&"
import script from "./AgencyContestParagraphsTable.vue?vue&type=script&lang=js&"
export * from "./AgencyContestParagraphsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235e73c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
